import { render, staticRenderFns } from "./EndorsementContractServices.vue?vue&type=template&id=7f4f5ce4"
import script from "./EndorsementContractServices.vue?vue&type=script&lang=js"
export * from "./EndorsementContractServices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports